import { Box, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import BusinessPartnerCard from '@features/supply/BusinessPartnerCard';
import { BusinessPartner } from '@features/supply/fakeSupplyChainData';
import { memo, useCallback, useState } from 'react';
import { LuSearch } from 'react-icons/lu';

interface BusinessPartnerGridProps {
  partners: BusinessPartner[];
}

const BusinessPartnerGrid = memo(({ partners }: BusinessPartnerGridProps) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const handleSelect = useCallback((id: string) => {
    setExpandedId(id);
  }, []);

  const handleClose = useCallback(() => {
    setExpandedId(null);
  }, []);

  return (
    <Flex
      direction="column"
      gap={4}
      p={4}
      background={'linear-gradient(rgba(131, 204, 255, 0.16) 0%, rgba(131, 204, 255, 0) 100%)'}
      borderRadius="xl"
    >
      <Heading size="md">Partners ({partners.length})</Heading>
      {partners.length === 0 ? (
        <Flex direction="column" alignItems="center" gap={2} py={10}>
          <Box color="text.secondary">
            <LuSearch size={32} />
          </Box>
          <Text color="text.secondary">No partners match your filters</Text>
        </Flex>
      ) : (
        <Grid
          templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
          gap={4}
          alignItems="start"
        >
          {partners.map((partner) => (
            <BusinessPartnerCard
              key={partner.id}
              partner={partner}
              isExpanded={expandedId === partner.id}
              onSelect={handleSelect}
              onClose={handleClose}
            />
          ))}
        </Grid>
      )}
    </Flex>
  );
});
BusinessPartnerGrid.displayName = 'BusinessPartnerGrid';

export default BusinessPartnerGrid;
